// extracted by mini-css-extract-plugin
export var equalColumn = "_fv-0";